module.exports = __webpack_public_path__ + "img/7200.f493dd85.jpg";